import React from "react";
import PropTypes from "prop-types";
import { formatDateForInput } from "../../../lib/utils";
import CurrencyCell from "./cells/CurrencyCell";
import InputCell from "./cells/InputCell";
import ActionCell from "./cells/ActionCell";

const PledgeRowEdit = ({
  pledgeId,
  amountPaid,
  outstandingAmount,
  pledgeDate,
  pledgeAmount,
  payOutSchedule,
  onFieldChange,
  onSubmit,
  onCancel,
  disableSubmit,
  showValidationErrors
}) => (
  <tr>
    <td className="text-right">{pledgeId}</td>
    <InputCell
      type="date"
      name="pledgeDate"
      value={formatDateForInput(pledgeDate) || ""}
      onChange={onFieldChange}
      required={true}
      showError={showValidationErrors}
    />
    <InputCell
      type="currency"
      name="pledgeAmount"
      value={pledgeAmount || ""}
      onChange={onFieldChange}
      required={true}
      showError={showValidationErrors}
    />
    <CurrencyCell value={amountPaid || 0} />
    <CurrencyCell value={outstandingAmount} />
    <InputCell
      type="text"
      name="payOutSchedule"
      value={payOutSchedule || ""}
      onChange={onFieldChange}
      required={false}
      showError={showValidationErrors}
    />
    <ActionCell onSubmit={onSubmit} onCancel={onCancel} disabled={disableSubmit} />
  </tr>
);

PledgeRowEdit.propTypes = {
  pledgeId: PropTypes.string.isRequired,
  amountPaid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  outstandingAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  pledgeDate: PropTypes.string.isRequired,
  pledgeAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  payOutSchedule: PropTypes.string.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool.isRequired,
  showValidationErrors: PropTypes.bool
};

PledgeRowEdit.defaultProps = {
  showValidationErrors: false
};

export default PledgeRowEdit;



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/PledgeRowEdit.jsx